export default __webpack_public_path__ + "6027ac4a28e1e5fba3d0cf1018424f74.svg";